import { Component, ViewChild, Input, isDevMode, OnChanges } from '@angular/core';
import { Church } from '../../church';
import { MapInfoWindow, MapMarker } from '@angular/google-maps';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.css']
})
export class MapComponent implements OnChanges {

  @Input() churches: Church[] = [];

  @ViewChild(MapInfoWindow) infoWindow: MapInfoWindow;
  markerPositions: google.maps.LatLngLiteral[] = [];
  myLocationMarker?: google.maps.LatLngLiteral;

  options: google.maps.MapOptions = {
    center: { lat: 50.774720, lng: 6.083920 },
    zoom: 10
  };

  markerOptions: google.maps.MarkerOptions = {
    draggable: false,
    icon: '/assets/icons/avail.png'
  };

  markerOptionsMy: google.maps.MarkerOptions = {
    draggable: false,
    icon: '/assets/icons/me.png'
  };

  selectedChurch: Church = new Church();

  constructor() { }

  ngOnChanges(): void {

    this.markerPositions.splice(0, this.markerPositions.length);
    let sumLat = 0;
    let sumLng = 0;
    let sum = 0;

    if (this.churches) {
      this.churches.forEach(c => {

        if (c.longitude !== 0 && c.latitude !== 0) {
          sum++;
          sumLat += c.latitude / 1000000.0;
          sumLng += c.longitude / 1000000.0;
          this.markerPositions.push({
            "lat": c.latitude / 1000000.0, "lng": c.longitude / 1000000.0
          });
        }
      });

      if (sum > 0) {
        this.options = {
          center: { lat: sumLat / sum, lng: sumLng / sum },
          zoom: 14
        };
      }
    }

    // Add user's current position
    this.locateUser();
  }

  locateUser(): void {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.myLocationMarker = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };

          if (isDevMode()) console.log('My position:', this.myLocationMarker);

          // Optionally center map on user position
          this.options = {
            center: this.myLocationMarker,
            zoom: 14,
          };
        },
        (err) => {
          console.warn('Geolocation failed:', err);
        }
      );
    } else {
      console.warn('Geolocation not supported by this browser.');
    }
  }

  openInfoWindow(marker: MapMarker, church: Church) {
    this.selectedChurch = church;
    if (isDevMode()) console.log('church=' + JSON.stringify(church));
    this.infoWindow.open(marker);
  }
}
